import React from "react";
import { Route, Switch } from "react-router-dom";

import Summary from "./Summary";
import List from "./List";
import BinTransfer from "./BinTransfer";
import UpdateViaUpload from "./UpdateViaUpload";
import EditMaterialType from "./EditMaterialType";

import SiluetaSummary from "./silueta/Summary";
import SiluetaList from "./silueta/List";

import StrGrList from "./str_gr/List";
import StrGrBinTransfer from "./str_gr/BinTransfer";

import StrRmList from "./str_rm/List";
import StrRmUpdateViaUpload from "./str_rm/UpdateViaUpload";
import StrRmEditMaterialType from "./str_rm/EditMaterialType";
import StrRmEditLotNumber from "./str_rm/EditLotNumber";
import StrRmBinTransfer from "./str_rm/BinTransfer";
import StrRmSummary from "./str_rm/Summary";

import PrymSummary from "./prym/Summary";
import PrymList from "./prym/List";
import PrymBinTransfer from "./prym/BinTransfer";
import PrymUpdateViaUpload from "./prym/UpdateViaUpload";
import PrymEditLotNumber from "./prym/EditLotNumber";
import PrymEditMaterialType from "./prym/EditMaterialType";
import PrymSplit from "./prym/Split";

import OtrSummary from "./otr/Summary";
import OtrList from "./otr/List";
import OtrBinTransfer from "./otr/BinTransfer";
import OtrUpdateViaUpload from "./otr/UpdateViaUpload";
import OtrEditLotNumber from "./otr/EditLotNumber";
import OtrEditMaterialType from "./otr/EditMaterialType";
import OtrSplit from "./otr/Split";

import TiepSummary from "./tiep/Summary";
import TiepList from "./tiep/List";
import TiepBinTransfer from "./tiep/BinTransfer";
import TiepUpdateViaUpload from "./tiep/UpdateViaUpload";
import TiepEditLotNumber from "./tiep/EditLotNumber";
import TiepEditMaterialType from "./tiep/EditMaterialType";
import TiepSplit from "./tiep/Split";

import AquaSummary from "./aqua/Summary";
import AquaList from "./aqua/List";
import AquaUpdateViaUpload from "./aqua/UpdateViaUpload";

import { Auth } from "_helpers";

function MaterialDetails({ match }) {
  const { path } = match;
  const { id } = match.params;
  const loggedInCustomerCode = Auth.getProfile().comp_code;
  if (loggedInCustomerCode === "SILUETA") {
    return (
      <Switch>
        <Route exact path={path} component={SiluetaList} />
        <Route path={`${path}/bin-transfer`} component={BinTransfer} />
        <Route path={`${path}/:id/summary`} component={SiluetaSummary} />
        <Route path={`${path}/update-via-upload`} component={UpdateViaUpload} />
      </Switch>
    );
  } else if (loggedInCustomerCode === "STR_GR") {
    return (
      <Switch>
        <Route exact path={path} component={StrGrList} />
        <Route path={`${path}/bin-transfer`} component={StrGrBinTransfer} />
        <Route path={`${path}/:id/summary`} component={Summary} />
        <Route path={`${path}/update-via-upload`} component={UpdateViaUpload} />
      </Switch>
    );
  } else if (loggedInCustomerCode === "STR") {
    return (
      <Switch>
        <Route exact path={path} component={StrRmList} />
        <Route path={`${path}/bin-transfer`} component={StrRmBinTransfer} />
        <Route path={`${path}/:id/summary`} component={StrRmSummary} />
        <Route path={`${path}/update-via-upload`} component={StrRmUpdateViaUpload} />
        <Route path={`${path}/material-type-transfer`} component={StrRmEditMaterialType} />
        <Route path={`${path}/lot-transfer`} component={StrRmEditLotNumber} />
      </Switch>
    );
  } else if (loggedInCustomerCode === "PRYM") {
    return (
      <Switch>
        <Route exact path={path} component={PrymList} />
        <Route path={`${path}/bin-transfer`} component={PrymBinTransfer} />
        <Route path={`${path}/:id/summary`} component={PrymSummary} />
        <Route path={`${path}/:id/split`} component={PrymSplit} />
        <Route path={`${path}/update-via-upload`} component={PrymUpdateViaUpload} />
        <Route path={`${path}/material-type-transfer`} component={PrymEditMaterialType} />
        <Route path={`${path}/lot-transfer`} component={PrymEditLotNumber} />
      </Switch>
    );
  } else if (loggedInCustomerCode === "OTR") {
    return (
      <Switch>
        <Route exact path={path} component={OtrList} />
        <Route path={`${path}/bin-transfer`} component={OtrBinTransfer} />
        <Route path={`${path}/:id/summary`} component={OtrSummary} />
        <Route path={`${path}/update-via-upload`} component={OtrUpdateViaUpload} />
        <Route path={`${path}/material-type-transfer`} component={OtrEditMaterialType} />
        <Route path={`${path}/lot-transfer`} component={OtrEditLotNumber} />
      </Switch>
    );
  } else if (loggedInCustomerCode === "TIEP") {
      return (
          <Switch>
              <Route exact path={path} component={TiepList} />
              <Route path={`${path}/bin-transfer`} component={TiepBinTransfer} />
              <Route path={`${path}/:id/summary`} component={TiepSummary} />
              <Route path={`${path}/update-via-upload/:receiptId`} component={TiepUpdateViaUpload} />
              <Route path={`${path}/material-type-transfer`} component={TiepEditMaterialType} />
              <Route path={`${path}/lot-transfer`} component={TiepEditLotNumber} />
          </Switch>
      );
  } else if (loggedInCustomerCode === "AQUA") {
      return (
          <Switch>
              <Route exact path={path} component={AquaList} />
              <Route path={`${path}/:id/summary`} component={AquaSummary} />
              <Route path={`${path}/update-via-upload/:receiptId`} component={AquaUpdateViaUpload} />
          </Switch>
      );
  } else {
    return (
      <Switch>
        <Route exact path={path} component={List} />
        <Route path={`${path}/bin-transfer`} component={BinTransfer} />
        <Route path={`${path}/material-type-transfer`} component={EditMaterialType} />
        <Route path={`${path}/:id/summary`} component={Summary} />
        <Route path={`${path}/update-via-upload`} component={UpdateViaUpload} />
      </Switch>
    );
  }
}

export { MaterialDetails };
